export enum AlertSortField {
  TaskNumber = 'taskNumber',
  Message = 'message',
  Developers = 'developers',
  TotalHours = 'totalHours',
  Date = 'date',
  Type = 'type'
}
